import React from 'react';
import SuccessTick from '../common/SuccessTick';

const SuccessAnimationAlert = (props) => {
    return (
        <>
            <section className="find-secmb-4">
                <div className="container small-container">
                    <div className="find-textBox">
                        {/* <i className="fal fa-check-circle fa-4x green-bg_color"></i> */}
                        <SuccessTick />
                        <h4 className="mt-3 mb-1">{props.title}</h4>
                        {props.text && (
                            <h5>{props.text}</h5>
                        )}
                    </div>
                </div>
            </section>  
        </>
    );
};

export default SuccessAnimationAlert;